import React from "react"
import FooterLabel from "../FooterLabel"
import FooterContentMobile from "./FooterContentMobile"

const MobileCheckoutFooter = () => {
	return (
		<footer className="bg-dark text-white">
			<section className="container">
				<div className="row justify-content-betwen align-items-center pt-5 pb-2">
					<FooterContentMobile/>
				</div>
				<FooterLabel/>
			</section>
		</footer>
	)
}

export default MobileCheckoutFooter
